export function organizeSongs(songHistory) {
    const now = new Date();
    const fiveYears = new Date(now.getMonth() +
        1 +
        "/" +
        now.getDate() +
        "/" +
        (now.getFullYear() - 5));
    const soonDef = 1000 * 60 * 60 * 24 * 90; // 90 days
    songHistory.know = [];
    songHistory.forgot = [];
    songHistory.dontknow = [];
    songHistory.recent = [];
    songHistory.expires = [];
    for (let i = 0; i < songHistory.songs.length; i++) {
        const song = songHistory.songs[i];
        let status = 0 /* SongStatus.Never */; // we've never sung it
        let latestDate = null;
        let addedDate = null;
        let expiresDate = null;
        if (song.history) {
            song.history.sort((a, b) => new Date(b.date).valueOf() - new Date(a.date).valueOf()); // soonist to latest
            latestDate = new Date(song.history[0].date);
            expiresDate = new Date(latestDate.getMonth() +
                1 +
                "/" +
                latestDate.getDate() +
                "/" +
                (latestDate.getFullYear() + 5));
            addedDate = new Date(song.history[song.history.length - 1].date);
            if (latestDate >= fiveYears) {
                status = 1 /* SongStatus.WeKnow */; // we know it
                if (now.valueOf() - addedDate.valueOf() < soonDef) {
                    status = 3 /* SongStatus.RecentAdd */; // recently added
                }
                if (expiresDate.valueOf() - now.valueOf() < soonDef) {
                    status = 4 /* SongStatus.ExpiresSoon */; // expires soon
                }
            }
            else {
                status = 2 /* SongStatus.Forgotten */; // it's been forgotten
            }
        }
        song.expiresDate = expiresDate;
        song.addedDate = addedDate;
        song.latestDate = latestDate;
        song.status = status;
        if (status === 1) {
            songHistory.know.push(song);
        }
        else if (status === 2) {
            songHistory.forgot.push(song);
            songHistory.dontknow.push(song);
        }
        else if (status === 3) {
            songHistory.recent.push(song);
            songHistory.know.push(song);
        }
        else if (status === 4) {
            songHistory.expires.push(song);
            songHistory.know.push(song);
        }
        else {
            songHistory.dontknow.push(song);
        }
    }
    return Promise.resolve(songHistory);
}
